(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2486],{

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 57456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68777);
/* harmony import */ var styles_breakpoints__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20881);


var SpinKeyframe = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
var buttonDefaultStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["height:70px;background-color:", ";border-radius:6px;> p{color:", ";}&:hover,&:focus{box-shadow:0 2px 8px 0 rgb(0 212 161 / 20%);}&:disabled{box-shadow:none;}.btn-ring:after{content:'';display:block;width:25px;height:25px;margin:2px;border-radius:50%;border:3px solid ", ";border-color:", " transparent;animation:", " 1.2s linear infinite;@media ", "{width:20px;height:20px;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.green;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, SpinKeyframe, styles_breakpoints__WEBPACK_IMPORTED_MODULE_0__/* .device.tablet */ .U.tablet);
var smallButtonStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["", " height:41px;border-radius:unset;color:", ";font-size:17px;font-weight:", ";line-height:1.23;max-width:635px;background-color:", ";padding:10px 20px;&:hover{background-color:", ";}"], buttonDefaultStyles, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.white;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.fontWeights.medium;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.blackPallet6;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.blackPallet7;
});
var smallGreenButtonStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["", " height:fit-content;width:fit-content;border-radius:0;color:", ";font-size:17px;font-weight:", ";line-height:1.23;padding:5px 10px;&:hover{background-color:", ";}&:disabled{background-color:", ";}"], buttonDefaultStyles, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.white;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.typography.fontWeights.medium;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.greenPallet6;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.grayPallet18;
});
var mediumButtonStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["", " height:55px;border-radius:unset;color:", ";font-size:17px;font-weight:", ";line-height:1.23;max-width:635px;&:hover{background-color:", ";}&:disabled{background-color:", ";}@media ", "{height:41px;}"], buttonDefaultStyles, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.white;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.typography.fontWeights.medium;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.greenPallet6;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.grayPallet18;
}, styles_breakpoints__WEBPACK_IMPORTED_MODULE_0__/* .device.tablet */ .U.tablet);
var mediumBlackButtonStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["", " height:55px;border-radius:unset;color:", ";font-size:17px;font-weight:", ";background-color:", ";line-height:1.23;max-width:635px;&:hover{background-color:", ";}&:disabled{background-color:", ";}@media ", "{height:41px;}"], buttonDefaultStyles, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.white;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.typography.fontWeights.medium;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.blackPallet6;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.blackPallet7;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.grayPallet18;
}, styles_breakpoints__WEBPACK_IMPORTED_MODULE_0__/* .device.tablet */ .U.tablet);
var mediumGreenButtonStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["", " height:fit-content;width:fit-content;border-radius:0;color:", ";font-size:17px;font-weight:", ";line-height:1.23;padding:22px 44px;&:hover{background-color:", ";}&:disabled{background-color:", ";}@media ", "{padding:17px 34px;}"], buttonDefaultStyles, function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.white;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.typography.fontWeights.medium;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.colors.greenPallet6;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.colors.grayPallet18;
}, styles_breakpoints__WEBPACK_IMPORTED_MODULE_0__/* .device.tablet */ .U.tablet);
var outlinedButtonStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["", " display:flex;justify-content:center;align-items:center;border:1px solid ", ";color:", ";background-color:transparent;border-radius:unset;&:hover{background-color:", ";color:", ";}"], buttonDefaultStyles, function (_ref26) {
  var theme = _ref26.theme;
  return theme.colors.blackPallet6;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.colors.blackPallet6;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.colors.blackPallet7;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.colors.white;
});
var underlineButtonStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["", " height:unset;border-radius:unset;color:", ";font-size:17px;font-weight:", ";line-height:1.23;width:auto;background-color:transparent;text-decoration:underline;vertical-align:text-bottom;text-underline-offset:5px;&:hover{color:", ";}&:disabled{color:", ";}&:hover,&:focus{box-shadow:none;}@media ", "{font-size:16px;}"], buttonDefaultStyles, function (_ref30) {
  var theme = _ref30.theme;
  return theme.colors.grayPallet9;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.typography.fontWeights.medium;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.colors.greenPallet6;
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.colors.grayPallet19;
}, styles_breakpoints__WEBPACK_IMPORTED_MODULE_0__/* .device.tablet */ .U.tablet);
var underlineGreenButtonStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["", " height:unset;border-radius:unset;color:", ";font-size:17px;font-weight:", ";line-height:1.23;width:auto;background-color:transparent;text-decoration:underline;vertical-align:text-bottom;text-underline-offset:5px;&:hover{color:", ";}&:disabled{color:", ";}&:hover,&:focus{box-shadow:none;}@media ", "{font-size:16px;}"], buttonDefaultStyles, function (_ref34) {
  var theme = _ref34.theme;
  return theme.colors.green;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.typography.fontWeights.medium;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.colors.greenPallet6;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.colors.grayPallet19;
}, styles_breakpoints__WEBPACK_IMPORTED_MODULE_0__/* .device.tablet */ .U.tablet);
var Button = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "button__Button",
  componentId: "sc-1p3d8t6-0"
})(["width:100%;background-color:transparent;display:flex;align-items:center;justify-content:center;cursor:pointer;&:disabled{cursor:not-allowed;}", " ", ""], function (_ref38) {
  var mode = _ref38.mode;

  switch (mode) {
    case 'google':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["height:58px;border:1px solid rgba(43,43,43,0.1);background-color:", ";> p{margin-left:16px;color:", ";}"], function (_ref39) {
        var theme = _ref39.theme;
        return theme.colors.white;
      }, function (_ref40) {
        var theme = _ref40.theme;
        return theme.colors.bluePallet1;
      });

    case 'small':
      return smallButtonStyles;

    case 'smallGreen':
      return smallGreenButtonStyles;

    case 'medium':
      return mediumButtonStyles;

    case 'mediumBlack':
      return mediumBlackButtonStyles;

    case 'mediumGreen':
      return mediumGreenButtonStyles;

    case 'underline':
      return underlineButtonStyles;

    case 'underlineGreen':
      return underlineGreenButtonStyles;

    case 'outlined':
      return outlinedButtonStyles;

    default:
      return buttonDefaultStyles;
  }
}, function (_ref41) {
  var withMargin = _ref41.withMargin;
  return withMargin ? (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["margin-top:24px;"]) : null;
});

/***/ }),

/***/ 14094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68777);

var Container = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "container__Container",
  componentId: "sc-1cmdyws-0"
})(["width:100%;", ""], function (_ref) {
  var size = _ref.size;

  switch (size) {
    case 'lg':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["max-width:1560px;padding:0 20px;"]);

    case 'md':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["max-width:1280px;padding:0 20px;"]);

    case 'sm':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["max-width:1064px;padding:0 20px;"]);

    default:
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["max-width:2000px;padding:0 20px;"]);
  }
});

/***/ }),

/***/ 89925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68777);
/* harmony import */ var _text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96861);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





function Error(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    children: data && data.map(function (item, idx) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(ErrorWrapper, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          type: "mode2",
          className: "error",
          children: item.message
        }, idx)
      }, idx);
    })
  });
}

var ErrorWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "error__ErrorWrapper",
  componentId: "sc-899iss-0"
})([".error{background-color:rgba(255,0,0,0.1);border:1px solid ", ";margin-top:24px;padding:8px;color:", ";text-align:center;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.red;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.red;
});
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(Error));

/***/ }),

/***/ 6035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Loader; },
/* harmony export */   "w": function() { return /* binding */ PageLoader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68777);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




function Loader() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: "lds-roller",
    "data-testid": "loader",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {})]
  });
}
function PageLoader() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PageLoaderWrapper, {
    "data-testid": "pageloader",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Loader, {})
  });
}
var PageLoaderWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "loader__PageLoaderWrapper",
  componentId: "sc-tkf924-0"
})(["position:fixed;z-index:999;top:0;left:0;width:100%;height:100%;background-color:rgba(255,255,255,0.8);display:flex;align-items:center;justify-content:center;"]);

/***/ }),

/***/ 93546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68777);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96861);
/* harmony import */ var _text_field__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80367);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










function TextFieldPassword(_ref) {
  var type = _ref.type,
      label = _ref.label,
      name = _ref.name,
      register = _ref.register,
      error = _ref.error,
      placeholder = _ref.placeholder,
      initialValue = _ref.initialValue;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
      hide = _useState[0],
      setHide = _useState[1];

  function togglePasswordVisibility() {
    setHide(function (prev) {
      return !prev;
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(TextFieldPasswordWrapper, {
    children: [label && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_text_field__WEBPACK_IMPORTED_MODULE_5__/* .TextFieldLabel */ .pU, {
      "data-testid": "password-field-label",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("label", {
        htmlFor: name,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          type: "mode2",
          fw: "light",
          children: label
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_text_field__WEBPACK_IMPORTED_MODULE_5__/* .TextFieldInput */ .Nl, {
      className: "input-wrapper",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("input", _objectSpread(_objectSpread({
        defaultValue: initialValue,
        type: hide ? type : 'text',
        id: name,
        "data-testid": "password-field",
        placeholder: placeholder
      }, register(name)), {}, {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()({
          invalid: Boolean(error)
        })
      })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "icon",
        onClick: togglePasswordVisibility,
        "data-testid": "icon",
        children: hide ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
          src: "/static/icons/eye.svg",
          width: 24,
          height: 24,
          "data-testid": "show-icon"
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
          src: "/static/icons/eye-close.svg",
          width: 24,
          height: 24,
          "data-testid": "hide-icon"
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_text_field__WEBPACK_IMPORTED_MODULE_5__/* .TextFieldError */ .ns, {
      children: (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        type: "mode2",
        fw: "medium",
        "data-testid": "password-field-error",
        children: error.message
      })
    })]
  });
}

var TextFieldPasswordWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "text-field-password__TextFieldPasswordWrapper",
  componentId: "sc-9oxcsl-0"
})(["margin-top:24px;.input-wrapper{position:relative;.icon{cursor:pointer;display:flex;position:absolute;top:50%;transform:translateY(-50%);right:24px;}}"]);
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(TextFieldPassword));

/***/ }),

/***/ 51951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68777);

var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "title__Title",
  componentId: "sc-13oetwq-0"
})(["letter-spacing:-0.5px;color:", ";text-transform:", ";text-decoration:", ";", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blackPallet1;
}, function (props) {
  return props.textTransform;
}, function (props) {
  return props.textDecoration;
}, function (_ref2) {
  var fw = _ref2.fw;

  switch (fw) {
    case 'light':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Light;"]);

    case 'medium':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Medium;"]);

    case 'bold':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Bold;"]);

    default:
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Regular;"]);
  }
}, function (props) {
  switch (props.type) {
    case 'mode1':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.titles.mode1.fontSize, props.theme.typography.titles.mode1.lineHeight);

    case 'mode2':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.titles.mode2.fontSize, props.theme.typography.titles.mode2.lineHeight);

    case 'mode3':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.titles.mode3.fontSize, props.theme.typography.titles.mode3.lineHeight);

    case 'mode4':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.titles.mode4.fontSize, props.theme.typography.titles.mode4.lineHeight);

    case 'mode5':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.titles.mode5.fontSize, props.theme.typography.titles.mode5.lineHeight);

    case 'mode6':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.titles.mode6.fontSize, props.theme.typography.titles.mode6.lineHeight);

    case 'mode7':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.titles.mode7.fontSize, props.theme.typography.titles.mode7.lineHeight);

    default:
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.titles["default"].fontSize, props.theme.typography.titles["default"].lineHeight);
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (Title);

/***/ }),

/***/ 92680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ CustomTypographyVariantValues; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68777);
/* harmony import */ var styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64575);
/* harmony import */ var styles_breakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20881);



var _theme$typography = styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .defaultTheme.typography */ .u.typography,
    fontWeights = _theme$typography.fontWeights,
    fontFamily = _theme$typography.fontFamily,
    colors = styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .defaultTheme.colors */ .u.colors;
var CustomTypographyVariantValues = ['body', 'bodyMedium', 'bodyMediumRegular', 'body1', 'body2', 'body3', 'body4', 'body5', 'h4One'];
var heading1Styles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:45px;line-height:1.21;font-weight:", ";@media ", "{font-size:25px;}"], fontWeights.semibold, styles_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .U.tablet);
var heading2Styles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:40px;line-height:1.21;font-weight:", ";@media ", "{font-size:25px;}"], fontWeights.bold, styles_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .U.tablet);
var heading3Styles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:32px;font-weight:", ";line-height:1.21;@media ", "{font-size:20px;line-height:1.2;}"], fontWeights.semibold, styles_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .U.tablet);
var heading4Styles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:25px;font-weight:", ";line-height:1.2;@media ", "{font-size:16px;line-height:1.31;}"], fontWeights.medium, styles_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .U.tablet);
var heading4OneStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["", " font-family:", ";@media ", "{font-size:22px;}"], heading4Styles, fontFamily.walsheimProMedium, styles_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .U.tablet);
var heading5Styles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:22px;line-height:1.22;font-weight:", ";@media ", "{font-size:17px;line-height:1.35;}"], fontWeights.regular, styles_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .U.tablet);
var heading6Styles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:20px;font-weight:", ";line-height:1.2;@media ", "{font-size:17px;line-height:1.35;}"], fontWeights.semibold, styles_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .U.tablet);
var bodyMediumStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:17px;line-height:1.35;font-weight:", ";color:", ";@media ", "{font-size:14px;font-weight:", ";}"], fontWeights.medium, styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .defaultTheme.colors.blackPallet6 */ .u.colors.blackPallet6, styles_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .U.tablet, fontWeights.regular);
var bodyMediumRegularStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:20px;font-weight:", ";line-height:1.2;@media ", "{font-size:16px;line-height:1.31;text-align:center;}"], fontWeights.regular, styles_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .U.tablet);
var body1Styles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:14px;line-height:1.35;text-align:center;@media ", "{font-size:12px;line-height:1.41;}"], styles_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .U.tablet);
var body2Styles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:16px;line-height:1.31;text-align:center;@media ", "{font-size:12px;line-height:1.41;}"], styles_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .U.tablet);
var body3Styles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:12px;line-height:1.41;"]);
var body4Styles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:17px;line-height:1.35;text-align:center;@media ", "{font-size:12px;line-height:1.41;}"], styles_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .U.tablet);
var body5Styles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:14px;line-height:1.35;"]);
var bodyStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:17px;line-height:1.35;font-weight:", ";@media ", "{font-size:16px;}"], fontWeights.regular, styles_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .U.tablet);
var Typography = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "styles__Typography",
  componentId: "sc-1pdy2ms-0"
})(["", " ", " ", ""], function (_ref) {
  var variant = _ref.variant;

  switch (variant) {
    case 'h1':
      return heading1Styles;

    case 'h2':
      return heading2Styles;

    case 'h3':
      return heading3Styles;

    case 'h4':
      return heading4Styles;

    case 'h4One':
      return heading4OneStyles;

    case 'h5':
      return heading5Styles;

    case 'h6':
      return heading6Styles;

    case 'bodyMedium':
      return bodyMediumStyles;

    case 'bodyMediumRegular':
      return bodyMediumRegularStyles;

    case 'body1':
      return body1Styles;

    case 'body2':
      return body2Styles;

    case 'body3':
      return body3Styles;

    case 'body4':
      return body4Styles;

    case 'body5':
      return body5Styles;

    case 'body':
      return bodyStyles;

    default:
      return bodyStyles;
  }
}, function (_ref2) {
  var color = _ref2.color;
  return color ? "color: ".concat(colors[color], ";") : '';
}, function (_ref3) {
  var fontWeight = _ref3.fontWeight;
  return fontWeight ? (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-weight:", ";"], fontWeights[fontWeight]) : null;
});
/* harmony default export */ __webpack_exports__["Z"] = ({
  Typography: Typography
});

/***/ }),

/***/ 72943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var components_common_container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14094);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70296);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);



 // import Text from "components/common/Text";





function AuthLayout(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .AuthLayoutWrapper */ .P, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("header", {
      className: "auth-header",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(components_common_container__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W, {
        size: "lg",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          href: "/",
          passHref: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "auth-header-logo",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
              src: "/static/logo-1.png",
              width: 25,
              height: 40
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          href: "/",
          passHref: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "auth-header-logo-mobile",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
              src: "/static/logo-2.svg",
              width: 105,
              height: 25
            })
          })
        })]
      })
    }), children]
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (AuthLayout);

/***/ }),

/***/ 70296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ AuthLayoutWrapper; },
/* harmony export */   "p": function() { return /* binding */ AuthContent; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68777);
/* harmony import */ var styles_breakpoints__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20881);


var AuthLayoutWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "styles__AuthLayoutWrapper",
  componentId: "sc-1roohyd-0"
})(["min-height:100vh;background-color:", ";overflow-x:hidden;.auth-header{display:flex;justify-content:center;> div{transition:all 0.3s ease;margin:40px 20px;display:flex;justify-content:space-between;align-items:center;}&-logo{display:flex !important;}&-logo-mobile{display:none !important;}&-actions{display:flex;align-items:center;> p{color:", ";}&-link{margin-left:25px;width:120px;height:50px;background-color:", ";display:flex;justify-content:center;align-items:center;}}}@media ", "{.auth-header{> div{margin:20px 10px;}&-logo{display:none !important;}&-logo-mobile{display:flex !important;}&-actions{> p{display:none;}}}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blue;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, styles_breakpoints__WEBPACK_IMPORTED_MODULE_0__/* .device.tablet */ .U.tablet);
var AuthContent = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "styles__AuthContent",
  componentId: "sc-1roohyd-1"
})(["width:100%;max-width:605px;background-color:", ";padding:60px 25px;margin:0 auto;margin-bottom:50px;transition:all 0.3s ease;@media ", "{max-width:100%;padding:48px 32px;min-height:calc(100vh - 65px);margin-bottom:0;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, styles_breakpoints__WEBPACK_IMPORTED_MODULE_0__/* .device.tablet */ .U.tablet);

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72717)


/***/ })

}]);